export const breakpointSm = '600px';
export const breakpointLg = '1280px';

export const imageFullWidthXs = 600;
export const imageFullWidthSmAndUp = 2000;

export const gutterXs = '1.5rem'; //24px
export const gutterSmAndUp = '3rem';
export const gutterFlexible = '1.6666';
export const maxWidth = '1680px';
